import { render, staticRenderFns } from "./DrawablePhoto.vue?vue&type=template&id=5c5d2b44&scoped=true&"
import script from "./DrawablePhoto.vue?vue&type=script&lang=js&"
export * from "./DrawablePhoto.vue?vue&type=script&lang=js&"
import style0 from "./DrawablePhoto.vue?vue&type=style&index=0&id=5c5d2b44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../mobile.zyp.one/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5d2b44",
  null
  
)

export default component.exports